import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import ProductCard from "@/components/feature/ProductCard";
import NewsCard from "@/components/feature/NewsCard";
import HeroSection from "./components/HeroSection";
import SectionHeading from "./components/SectionHeading";
import { products } from "@/mocks/products";
import { news } from "@/mocks/news";

const values = [
  {
    icon: "ri-leaf-line",
    title: "真实用料",
    desc: "真实果汁、真实果酱与可溯源原料，让风味来自食材本身。",
  },
  {
    icon: "ri-heart-2-line",
    title: "少糖配方",
    desc: "反复调校的糖酸比，减糖不减味，吃得安心也更清爽。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "用心工艺",
    desc: "小批量慢工制作，把每一份甜都当成作品来对待。",
  },
];

export default function Home() {
  const featured = products.slice(0, 4);
  const latestNews = news.slice(0, 3);

  return (
    <SiteLayout>
      <HeroSection />

      {/* 产品快览 */}
      <section className="w-full px-4 md:px-10 py-16 md:py-20 bg-background-50">
        <SectionHeading
          eyebrow="产品快览"
          title="精选代表产品"
          desc="从软糖到曲奇，从巧克力到气泡饮，每一款都围绕「真实」与「好吃」打磨。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-600 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-50"
            >
              查看全部产品资讯
              <i className="ri-arrow-right-line leading-none"></i>
            </Link>
          }
        />
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>

      {/* 品牌理念 */}
      <section className="w-full bg-secondary-50">
        <div className="w-full px-4 md:px-10 py-16 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative w-full h-[320px] md:h-[440px] rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20artistic%20still%20life%20of%20handmade%20candy%20and%20cookies%20with%20fresh%20fruits%20on%20a%20cream%20table%2C%20soft%20natural%20light%2C%20coral%20accents%2C%20elegant%20editorial%20food%20photography%2C%20high%20detail%2C%20cozy%20sweet%20atmosphere&width=1000&height=1300&seq=tx-home-values&orientation=portrait"
              alt="糖心VLGO 品牌理念展示"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
              <span className="w-6 h-[2px] bg-accent-500"></span>
              品牌理念
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-extrabold text-foreground-950 tracking-tight">
              把自然的甜
              <br />
              认真装进每一颗糖
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              糖心VLGO 创立于对「真实味道」的执念。我们希望甜点带来的不只是甜，
              还有安心与温暖。这份坚持，体现在我们对原料与工艺的每一次选择里。
            </p>
            <div className="mt-8 flex flex-col gap-5">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-4">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shrink-0">
                    <i className={`${v.icon} text-2xl leading-none`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 最新资讯 */}
      <section className="w-full px-4 md:px-10 py-16 md:py-20 bg-background-50">
        <SectionHeading
          eyebrow="最新资讯"
          title="品牌动态与产品发布"
          desc="了解糖心VLGO 的新品发布、品牌活动与行业观察。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-accent-600"
            >
              <i className="ri-newspaper-line leading-none"></i>
              进入资讯中心
            </Link>
          }
        />
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestNews.map((n) => (
            <NewsCard key={n.id} article={n} />
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="relative w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20coral%20and%20pink%20abstract%20gradient%20background%20with%20soft%20flowing%20shapes%20and%20subtle%20candy%20elements%2C%20artistic%20minimal%20brand%20banner%2C%20soft%20lighting%2C%20elegant%20and%20inviting&width=1920&height=700&seq=tx-home-cta&orientation=landscape"
          alt="糖心VLGO 品牌合作邀请"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 to-foreground-950/45"></div>
        <div className="relative z-10 w-full px-4 md:px-10 py-16 md:py-20">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-background-50 tracking-tight">
              想和我们一起，把甜做得更认真？
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-50/85 leading-relaxed">
              无论是渠道合作、品牌联名还是媒体采访，欢迎随时联系我们，一起分享关于甜蜜的更多可能。
            </p>
            <Link
              to="/contact"
              className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-50"
            >
              <i className="ri-contacts-line leading-none"></i>
              联系我们
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}